import React, { useState, useEffect } from 'react';
import EmailContent from './EmailContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './EmailSablonTooltips';


const cardStyle = { padding: 10 };
const EmailBase = (props) => {

  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          Email sablonok
          <CustomTooltip text={getTooltip('emailsablon')} id="emailsablonTT" />
          {/* <YouTube data={videoData} /> */}
        </div>
        <div style={cardStyle}>
          <EmailContent globals={props.globals} />
        </div>
      </div>
    </div>
  );
};

export default EmailBase;